// ページ内スクロール
$('a[href^="#"]').click(function () {
    const speed = 600;
    let href = $(this).attr("href");
    let target = $(href == "#" || href == "" ? "html" : href);
    let position = target.offset().top;
    $("body,html").animate({ scrollTop: position }, speed, "swing");
    return false;
  });

  
  // ページトップjs スクロールした際の動きを関数でまとめる
  // 画面をスクロールをしたら動かしたい場合の記述
  $(window).scroll(function () {
    PageTopAnime(); // スクロールした際の動きの関数を呼ぶ
  });

  function PageTopAnime() {
    var scroll = $(window).scrollTop(); // スクロール値を取得
    var wH = window.innerHeight; // 画面の高さを取得
    var footer = $(".site-footer"); // footerの位置を取得
var footerPos = footer.length ? footer.offset().top : 0;

    if (scroll >= 1000 && scroll <= footerPos - 500) {
      // 1000pxスクロールしたらaddClass
      $('#product_fixbtm').addClass('active');
    } else {
      // それ以外は
      $('#product_fixbtm').removeClass('active');
    }
  }
  
  
  // ページトップjs スクロールした際の動きを関数でまとめる
  // 画面をスクロールをしたら動かしたい場合の記述
  $(window).scroll(function () {
    PageTopAnime2(); // スクロールした際の動きの関数を呼ぶ
  });

  function PageTopAnime2() {
    var scroll = $(window).scrollTop(); // スクロール値を取得
    var wH = window.innerHeight; // 画面の高さを取得
    var footer = $(".site-footer"); // footerの位置を取得
var footerPos = footer.length ? footer.offset().top : 0;

    if (scroll >= 1000 && scroll <= footerPos - 500) {
      // 1000pxスクロールしたらaddClass
      $('.footerbtn_backto_top').addClass('is-fixed');
    } else {
      // それ以外は
      $('.footerbtn_backto_top').removeClass('is-fixed');
    }
  }